import type { FieldDef } from '../types'
import { validateCron } from './validateCron'

export function isFormValid(fields: FieldDef[], values: Record<string, unknown>): boolean {
  return fields.every((field) => {
    if (field.required === false) {
      return !field.validate || field.validate(values[field.name]) === null
    }
    if (field.type === 'checkbox') {
      return true
    }
    if (field.type === 'number') {
      const val = values[field.name]
      const numericOk = val !== '' && val !== null && val !== undefined && !isNaN(Number(val))
      return numericOk && (!field.validate || field.validate(val) === null)
    }
    if (field.type === 'cron') {
      const val = String(values[field.name] ?? '').trim()
      return val.length > 0 && validateCron(val) === null
    }
    const hasValue = String(values[field.name] ?? '').trim().length > 0
    return hasValue && (!field.validate || field.validate(values[field.name]) === null)
  })
}
